import { ProductFormValues, ProductFormViolation } from 'types/state';
import { stringIsEmpty, stringIsNaturalNumber } from 'utils/stringUtils';

export const sanitizeProductFormValues = (target: HTMLInputElement) => {
  const { name, value } = target;

  switch (name) {
    case 'defaultAmount':
      return stringIsEmpty(value) || stringIsNaturalNumber(value);
    default:
      return true;
  }
};

export const validateProductFormValues = (
  values: ProductFormValues
): ProductFormViolation[] => {
  const violations: ProductFormViolation[] = [];

  if (stringIsEmpty(values.name)) {
    violations.push({
      name: 'NameMissed',
    });
  }

  if (stringIsEmpty(values.defaultAmount)) {
    violations.push({
      name: 'DefaultAmountMissed',
    });
  }

  if (stringIsEmpty(values.defaultPartnerComission)) {
    violations.push({
      name: 'DefaultPartnerCommissionMissed',
    });
  }

  return violations;
};
